<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" @close="$emit('close')" title="禁用人员" width="30%"  :modal-append-to-body="false">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="姓名" prop="nickName">
                    {{ form.nickName }}
                </el-form-item>
                <el-form-item label="登陆账号" prop="userName">
                    {{ form.userName }}
                </el-form-item>
                <el-form-item label="禁用备注" prop="disableRemark">
                    <el-input type="textarea" v-model="form.disableRemark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="$emit('close')">关闭</el-button>
                <el-button type="primary" @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        row: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            form: { status: false },
        };
    },
    created() {
        this.form = { status: false }
        if (Object.keys(this.row).length) {
            this.form = {
                ...this.row,
                userId: this.row.userId,
                nickName: this.row.nickName,
                userName: this.row.userName,
                status: 1,
                disableRemark: this.row.forbiddenRemark
            }
        }
    },
    mounted() { },
    methods: {
        submit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.form.deptId = this.row.deptId
                    this.form.orderNum = 0
                    this.form.ancestors = 0
                    this.form.parentId = 100
                    this.$emit('confirm', this.form)
                }
            })
        }
    },
};
</script>
<style scoped></style>